import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/afterschool5.jpeg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


function Afterschool2() {
  const { t } = useTranslation();

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#afterschool-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 

    const whyItems = t("programs.afterschool.why.items", { returnObjects: true });
    const approachItems = t("programs.afterschool.approach.items", { returnObjects: true });
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            {t("programs.afterschool.titleLeft")} <span className="purple">{t("programs.afterschool.titleRight")}</span>
            </h1>
            <p className="home-about-body">{t("programs.afterschool.intro")}</p>
            <h2>{t("programs.afterschool.why.title")}</h2>
            <p className="home-about-body">{t("programs.afterschool.why.lead")}</p>
            <ul className="home-about-body">
              {Array.isArray(whyItems)
                ? whyItems.map((item) => (
                    <li key={item.label}>
                      <span className="purple">{item.label}:</span> {item.text}
                    </li>
                  ))
                : null}
            </ul>

            <h2>{t("programs.afterschool.approach.title")}</h2>
            <ul className="home-about-body">
              {Array.isArray(approachItems)
                ? approachItems.map((item) => (
                    <li key={item.label}>
                      <span className="purple">{item.label}:</span> {item.text}
                    </li>
                  ))
                : null}
            </ul>

          <Button onClick={handleClick} className="custom-yellow-btn">
            {t("common.registerHere")}
          </Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt={t("programs.afterschool.images.sideAlt")} />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>{t("common.summerInternshipProgram")}</h1>
          <Container>    
        {/* Responsive Video */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title={t("common.youtubeVideo")}
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
              <h1>{t("common.testimonials")}</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Afterschool2;
